import { render, staticRenderFns } from "./AccountSettingBilling.vue?vue&type=template&id=fed7fa30&scoped=true&"
import script from "./AccountSettingBilling.vue?vue&type=script&lang=js&"
export * from "./AccountSettingBilling.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingBilling.vue?vue&type=style&index=0&id=fed7fa30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed7fa30",
  null
  
)

export default component.exports